import { render, staticRenderFns } from "./NewGenericBTable.vue?vue&type=template&id=7f46a230&scoped=true"
import script from "./NewGenericBTable.vue?vue&type=script&lang=js"
export * from "./NewGenericBTable.vue?vue&type=script&lang=js"
import style0 from "./NewGenericBTable.vue?vue&type=style&index=0&id=7f46a230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f46a230",
  null
  
)

export default component.exports